import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=6828cc1a&scoped=true"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"
import style0 from "./LanguageList.vue?vue&type=style&index=0&id=6828cc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828cc1a",
  null
  
)

export default component.exports